export default __webpack_public_path__ + "static/media/pdfThumbnail.1745b3d8.svg";